import React from "react";
import RadioField from "../../../components/FinalForm/RadioField";
import InputField from "../../../components/FinalForm/InputField";
import {ImageGallery} from "../../../components/image-modal/ImageGallery";

const DriverClubForm = ({values, title = "VIP Sky Lounge", part = 5, errors, submitFailed, disabled = false}) => {

    let driversClubGallery = [
        {src: "https://enigoo-legends.s3.eu-central-1.amazonaws.com/fe_photos/terrace_club_3.jpg"},
        {src: "https://enigoo-legends.s3.eu-central-1.amazonaws.com/fe_photos/terrace_club_6.jpg"},
        {src: "https://enigoo-legends.s3.eu-central-1.amazonaws.com/fe_photos/terrace_club_7.jpg"},
        {src: "https://enigoo-legends.s3.eu-central-1.amazonaws.com/fe_photos/terrace_club_10.png"},
        {src: "https://enigoo-legends.s3.eu-central-1.amazonaws.com/fe_photos/terrace_club_11.png"},
    ]

    return (
        <div className={`flex flex-col bg-white border border-grey-200 lg:p-8 p-2 pb-8 w-full mb-2 text-base`}>
            <div className="flex flex-row w-full mb-6">
                <h4 className="font-bold"><span className={"text-legendyColor"}>ČÁST {part}</span> - {title}</h4>
            </div>
            <div className={"mb-5"}><ImageGallery images={driversClubGallery} showTitle={false} cols={5}
                                                  showLabel={false}/></div>
            <div className={"w-full flex flex-col space-y-5"}>
                <div className={"font-bold"}>Chcete si naši slavnost užít opavdu naplno? Staňte se součástí
                    exkuluzivního VIP Sky Lounge!
                </div>
                <div><strong>Během slavnosti LEGENDY</strong> můžete využít skvělého zázemí a prémiových služeb, které
                    jsou určené jen pro vybrané hosty.
                </div>
                <br/>
                <div>Užijte si klidovou zónu, výborné občerstvení, jedinečný výhled a prostor k příjemné konverzaci v
                    příjemném prostředí.
                </div>
                <div><strong><u>Po schválení Vašeho vozu</u></strong> získáte možnost zakoupit si <strong>zvýhodněnou vstupenku
                    do VIP Sky Lounge za 1.590 Kč / den</strong> - místo standardní ceny 2.990 Kč.
                </div>
                <div>Odkaz pro nákup této vstupenky Vám zašleme v potvrzovacím e-mailu o schválení vozu.</div>
                <div>Dopřejte si zážitek, který povýší Vaši účast na LEGENDÁCH na zcela novou úroveň.</div>

            </div>
        </div>
    )

}
export default DriverClubForm;
